module.exports = __webpack_public_path__ + "static/media/singsnap-app_2screen.1fdb50dd.png";